import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonComponent } from 'ui-component/src/public-api';

@Component({
  selector: 'app-session-ended-dialog',
  imports: [CommonModule, ButtonComponent],
  templateUrl: './session-ended-dialog.component.html',
  styleUrl: './session-ended-dialog.component.scss',
  providers: [DialogService],
})
export class SessionEndedDialogComponent {
  title = 'Session Ended';
  description = 'Your user role has changed. For security reasons, please log in again.';
  illustration = 'assets/icon/timeout.svg';

  constructor(
    private dialogConfig: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private router: Router
  ) {
    // Allow customization through config if needed
    this.title = this.dialogConfig.data?.title ?? this.title;
    this.description = this.dialogConfig.data?.description ?? this.description;
    this.illustration = this.dialogConfig.data?.illustration ?? this.illustration;
  }

  onLoginAgain() {
    this.ref.close();
    this.router.navigate(['/login']);
  }
}
